var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-container"},[(_vm.chat_state == 'INCOMING' || _vm.chat_state == 'CONNECTING')?_c('incoming-chat'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }